import { Stack, Text, useTheme } from '@fluentui/react';
import { TimeForTeamsLogo } from '@pum-spark/projectum-logos-react';

export const TimeLoaderFullscreen = ({ children, text = 'Time for Teams is loading' }: { text?: React.ReactNode; children?: React.ReactNode }) => {
    const theme = useTheme();

    return (
        <Stack styles={{ root: { position: 'absolute', inset: 0, alignItems: 'center' } }}>
            <Stack>
                <TimeForTeamsLogo height={300} />
                {/* <Stack horizontalAlign="center">{txt}</Stack> */}
                <Stack horizontalAlign="center" tokens={{ childrenGap: 10 }}>
                    <Text styles={{ root: { color: theme.semanticColors.bodyText } }} variant="large">
                        {/* {text} */}
                        Time For Teams is loading.
                    </Text>
                    <Text styles={{ root: { color: theme.semanticColors.bodyText } }} variant="large">
                        {/* {text} */}
                        It will be ready any moment now.
                    </Text>
                </Stack>
                {children}
            </Stack>
        </Stack>
    );
};
